var BULLET = '•';
export default (value => value === null || value === void 0 ? void 0 : value.replace(/\*/g, BULLET));
//# sourceMappingURL=index.js.map